import { render } from "./ModalChooseNumberOfGuests.vue?vue&type=template&id=5c108ac3&scoped=true"
import script from "./ModalChooseNumberOfGuests.vue?vue&type=script&lang=js"
export * from "./ModalChooseNumberOfGuests.vue?vue&type=script&lang=js"

import "./ModalChooseNumberOfGuests.vue?vue&type=style&index=0&id=5c108ac3&scoped=true&lang=css"

import exportComponent from "/var/www/html/online-ordering/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c108ac3"]])

export default __exports__